export default function FormatCurrency(amount?: number, symbol?: string, showDecimals?: boolean): string {
    showDecimals = showDecimals ?? false;

    if (!symbol) {
        symbol = "€";
    }

    if (!amount) {
        return `${symbol}0`;
    }

    let value;

    if (showDecimals) {
        value = (Math.round(amount*100)/100).toFixed(2).toString();
    } else {
        value = Math.round(amount).toString();
    }
    

    if (value.length > 3) {
        value = String(value).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');

    }

    return `${symbol}${value}`;
}